import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { FaTachometerAlt, FaUnlockAlt } from "react-icons/fa";
import "./styles.scss";
import "./custom.scss";
import Drawer from "@material-ui/core/Drawer";
import { Link } from "react-router-dom";
import { useStyles } from "./styles";
import { FaBars } from "react-icons/fa";
import { MdOutlineManageSearch } from "react-icons/md";
import sidebarBg1 from "./bg1.jpg";
import sidebarBg2 from "./bg2.jpg";

const listBackround = [
  {
    id: 1,
    name: sidebarBg1,
    description: "twinkle",
  },
  {
    id: 2,
    name: sidebarBg2,
    description: "wolf",
  },
];

const Sidebar = ({
  image,
  imageBackground,
  collapsed,
  rtl,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
  props,
  activeMenu,
  handleOnClick,
  handleCollapsedSideBar,
  open,
  HandleToggleMenu,
}) => {
  const classes = useStyles();

  const MenuChangeManagement =
    props.DataLayout &&
    props.DataLayout.filter((item) => {
      return item.url !== "/MenuRole" && item.url !== "/Dashboard";
    });

  const MenuDashboard =
    props.DataLayout &&
    props.DataLayout.filter((item) => {
      return item.url === "/MenuRole" || item.url === "/Dashboard";
    });

  return (
    <div style={{ zIndex: "200000" }}>
      <Drawer
        className={`${
          collapsed ? classes.minidrawer : `${classes.drawer} drawer`
        } drawer-wrap-container`}
        variant="permanent"
        classes={{
          paper: collapsed
            ? classes.minidrawer
            : `drawer ${classes.drawerPaper}`,
        }}
      >
        <div className={`${classes.drawerContainer} drawer-wrap-container`}>
          <ProSidebar
            image={
              image === true ? listBackround[imageBackground - 1]?.name : false
            }
            // image={false}
            rtl={rtl}
            collapsed={collapsed}
            toggled={toggled}
            breakPoint="md"
            onToggle={handleToggleSidebar}
          >
            <SidebarHeader>
              {/* <div >
               
              </div> */}
              <Menu style={{ height: "69px" }}>
                <MenuItem
                  icon={
                    <FaBars
                      onClick={() => handleCollapsedSideBar(true)}
                      style={{ fontSize: "24px", color: "#ccc" }}
                    />
                  }
                  style={{
                    color: "#fff",
                    boxSizing: "border-box",
                    overflow: "hidden",
                    textOverflow: "hidđen",
                    whiteSpace: "nowrap",
                    // letterSpacing: "1px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      fontSize: 30,
                      marginLeft: "20px",
                    }}
                  >
                    ITSM
                  </span>
                </MenuItem>
              </Menu>
            </SidebarHeader>

            <SidebarContent>
              <Menu>
                <SubMenu
                  title="Change Management"
                  icon={<MdOutlineManageSearch />}
                  open={open}
                  onClick={HandleToggleMenu}
                >
                  {MenuChangeManagement?.map((item, index) => (
                    <MenuItem
                      // icon={index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                      key={item.id}
                      className={`${
                        activeMenu.id === item.id ? "active-menu" : ""
                      }`}
                      onClick={(event) => event.stopPropagation()}
                    >
                      {" "}
                      {item.url.includes('v2') ? <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={() =>
                            handleOnClick({ id: item.id, url: item.url })}>{item.name}</a> :
                        <Link
                          className="link"
                          to={item.url}
                          key={item.id}
                          onClick={() =>
                            handleOnClick({ id: item.id, url: item.url })
                          }
                        >
                          {/* <ListItem button key={item.id}>
                        <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                        <ListItemText primary={item.name} />
                      </ListItem> */}{" "}
                          {`${item.name}`}
                        </Link>
                      }
                    </MenuItem>
                  ))}
                </SubMenu>
                {MenuDashboard?.map((item, index) => (
                  <MenuItem
                    icon={
                      index % 2 === 0 ? <FaUnlockAlt /> : <FaTachometerAlt />
                    }
                    suffix={<span className="badge red"></span>}
                    key={item.id}
                    className={`${
                      activeMenu.id === item.id ? "active-menu" : ""
                    }`}
                  >
                    <Link
                      className="link"
                      to={item.url}
                      key={item.id}
                      onClick={() =>
                        handleOnClick({ id: item.id, url: item.url })
                      }
                    >{`${item.name}`}</Link>
                  </MenuItem>
                ))}
              </Menu>
            </SidebarContent>

            <SidebarFooter style={{ textAlign: "left" }}>
              <Menu></Menu>
            </SidebarFooter>
          </ProSidebar>
        </div>
      </Drawer>
    </div>
  );
};

export default Sidebar;
